import { createRoute } from '@tanstack/react-router';
// Sanctioned app→module bridge (ADR-0072).
import { AProposScreen } from '@/ui/v2/AProposScreen';
import { indexableHeadWithBreadcrumb } from '@/ui/seo';
import { Route as AppLayoutRoute } from './app-layout';

export const Route = createRoute({
  getParentRoute: () => AppLayoutRoute,
  path: 'a-propos',
  component: AProposScreen,
  head: () => indexableHeadWithBreadcrumb('/a-propos'),
});
